module.exports = __webpack_public_path__ + "img/lifechamps-members.a51354e7.svg";